import { newsApi } from '@/api/index';

const state = {
    loading: true,
    carouselData: [],
    noDataMode: false,
    loadingShow: false,
    currentListData: [], // 当前选中tab下的所有数据
    loadPrev: '/m/app/tabs/1.json?plat=m',
    loadNext: '/m/app/tabs/1.json?plat=m', // 当前链接为最初始二级子标题（标题名及其下的数据链接）链接；
};

const getters = {
    getLoading: state => state.loading,
    getCarouselData: state => state.carouselData,
    getNoDataMode: state => state.noDataMode,
    getLoadingShow: state => state.loadingShow,
    getCurrentListData: state => state.currentListData, // 当前选中tab下的所有数据
    getLoadPrev: state => state.loadPrev,
    getLoadNext: state => state.loadNext
};

const actions = {
    newsListApi ({ commit, state, rootState }, { urlApi }) {
        state.loadingShow = true;
        return newsApi.getNewsList(urlApi).then(response => {
            commit('getNewsList', response);
        }, error => {
            console.log('error', error);
        });
    }
};

const mutations = {
    getNewsList (state, params) { // 请求新闻列表
        console.log('getNewsList');
        state.loading = false;
        if (params.recommend) {
            state.carouselData = params.recommend;
        }
        if (params.articles.length) {
            state.noDataMode = false;
            state.loadingShow = false;
            state.currentListData = params.articles;
            state.loadPrev = params.prev.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
            state.loadNext = params.next.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
        } else {
            state.noDataMode = true;
            state.loadingShow = false;
        }
    },
    setLoading (state, params) { // loading模块显隐
        state.loading = params;
    },
    setLoadNext (state, params) { // 下一个请求地址
        state.loadNext = params;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/homeListStore.js